import ScaleLoader from 'react-spinners/ScaleLoader';
export default function Loader() {
	return <ScaleLoader loading height={10} color="#E6E5FB" />;
}
